import { useState } from "react";
import content from "../../data/content";
import CtaBanner from "../../components/CtaBanner";
import "./Portfolio.css";

const { portfolio } = content;

// Unique categories (excluding "全部")
const categoryList = [...new Set(portfolio.items.map((i) => i.category))];

// Representative image per category (first image of first item in that category)
const categoryCovers = {
  全部: "/images/portfolio/soft-mist-brow/1.jpg",
};
categoryList.forEach((cat) => {
  const item = portfolio.items.find(
    (i) => i.category === cat && i.images.length > 0
  );
  if (item) categoryCovers[cat] = item.images[0];
});

const allCategories = ["全部", ...categoryList];

export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const filtered =
    selectedCategory === "全部"
      ? portfolio.items
      : portfolio.items.filter((i) => i.category === selectedCategory);

  const handleBack = () => setSelectedCategory(null);

  return (
    <div className="portfolio-page">
      <section className="portfolio-header">
        <p className="page-label">Portfolio</p>
        <h1 className="page-heading">{portfolio.heading}</h1>
        <p className="portfolio-sub">{portfolio.subheading}</p>
      </section>

      {selectedCategory === null ? (
        /* ---- Category Picker ---- */
        <section className="portfolio-picker">
          <div className="portfolio-picker__grid">
            {allCategories.map((cat) => (
              <button
                key={cat}
                className="portfolio-picker__card"
                onClick={() => setSelectedCategory(cat)}
              >
                <img
                  className="portfolio-picker__img"
                  src={categoryCovers[cat]}
                  alt={cat}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <div className="portfolio-picker__overlay" />
                <span className="portfolio-picker__label">{cat}</span>
              </button>
            ))}
          </div>
        </section>
      ) : (
        <>
          {/* ---- Back + Filter Tabs ---- */}
          <div className="portfolio-filter">
            <button className="portfolio-filter__back" onClick={handleBack}>
              ← 返回分類
            </button>
            <div className="portfolio-filter__tabs">
              {allCategories.map((cat) => (
                <button
                  key={cat}
                  className={`portfolio-filter__btn ${
                    selectedCategory === cat
                      ? "portfolio-filter__btn--active"
                      : ""
                  }`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* ---- Service Groups ---- */}
          <section className="portfolio-section">
            <div className="portfolio-section__inner">
              {filtered.map((item) => (
                <div key={item.slug} className="portfolio-group">
                  <h2 className="portfolio-group__name">{item.name}</h2>
                  <p className="portfolio-group__category">{item.category}</p>

                  <div className="portfolio-group__grid">
                    {item.images.map((src, i) => (
                      <div key={i} className="portfolio-group__item">
                        <img
                          src={src}
                          alt={`${item.name} ${i + 1}`}
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                        <div
                          className="img-placeholder"
                          style={{ display: "none" }}
                        >
                          Photo {i + 1}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      <CtaBanner />
    </div>
  );
}
